import { render } from "./ShippingInfo.vue?vue&type=template&id=83d71050"
import script from "./ShippingInfo.vue?vue&type=script&lang=js"
export * from "./ShippingInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__